module.exports = __webpack_public_path__ + "img/empty-state-widget.3a4a89bf.svg";